<template>

  <v-carousel light v-model="currentStep" 
    :continuous="false"
    hide-delimiter-background
    delimiter-icon="mdi-minus">
    <v-carousel-item>
      <v-sheet height="100%" tile>
        <v-row align="center" class="fill-height" >
          <v-spacer />
          <v-col cols="9" class="display-1">
            Tips for screensharing with Google Meet
          </v-col>
          <v-spacer />
        </v-row>
      </v-sheet>
    </v-carousel-item>

    <v-carousel-item v-for="(tip, index) in tips" :key="index">
      <v-sheet height="100%" tile>
        <v-row class="pt-10">
          <v-spacer />
          <v-col cols="10" class="display-1">
            {{ tip.title }}
            <v-divider class="mt-5"></v-divider>
          </v-col>
          <v-spacer />
        </v-row>
        <v-row>
          <v-spacer />
          <v-col cols="10">
            <v-img :src="tip.image" />
          </v-col>
          <v-spacer />
        </v-row>
      </v-sheet>
    </v-carousel-item>


    <v-carousel-item>
      <v-sheet height="100%" tile>
        <v-row align="center" class="fill-height" >
          <v-spacer />
          <v-col cols="9" class="display-1 text-center">
            Are you ready?

            <v-row class="mt-10 d-flex flex-wrap justify-space-around">
              <v-form>
                <v-checkbox v-model="disableGuide" label="Don't show this guide again"></v-checkbox>
                <v-btn large color="primary" @click="join" :loading="submitting" :disabled="submitting">
                  <v-icon left>screen_share</v-icon>
                  <span class="font-weight-black">GO TO GOOGLE MEET</span>
                </v-btn>
              </v-form>

            </v-row>
          </v-col>
          <v-spacer />
        </v-row>
      </v-sheet>
    </v-carousel-item>

  </v-carousel>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data: () => ({
    currentStep: 0,
    tips: [
      {title: 'You might need to sign in to your Gmail account', image: require('@/assets/google_meet/1_login.png')},
      {title: 'Then click "Join now" to enter the meeting', image: require('@/assets/google_meet/2_join.png')},
      {title: 'Click "Present now" to share your screen', image: require('@/assets/google_meet/3_entire_screen.png')},
      {title: 'Confirm by selecting your screen and clicking Share', image: require('@/assets/google_meet/4_confirm.png')},
    ],
    submitting: false,
    disableGuide: false
  }),
  computed: {
    ...mapGetters({
      user: 'user'
    }),
  },
  methods: {
    async join() {
      this.submitting = true
      if (this.disableGuide) {
        // Update the user object in firebase
        this.user.data.showGoogleMeetGuide = false
        await this.$store.dispatch('updateUser', this.user)
      }
      // Reset to the start of the instructions for future screenshares
      this.currentStep = 0
      this.submitting = false
      this.$emit('finishedGuide')
    }
  }
}
</script>